import { render, staticRenderFns } from "./RobberyPersonalPropertyCountQuestion.vue?vue&type=template&id=b7ce0e44&scoped=true"
import script from "./RobberyPersonalPropertyCountQuestion.vue?vue&type=script&lang=ts"
export * from "./RobberyPersonalPropertyCountQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ce0e44",
  null
  
)

export default component.exports